import React, { Component, PropTypes } from 'react';
import { Form, SubmissionError } from 'redux-form';
import { browserHistory } from 'react-router';
import partial from 'lodash/partial';
import AnimatedButton from 'common/components/animated_button';
import ModalDialog from 'common/components/modal/modal_dialog';
import AddStepIntro from 'presentations/containers/add_step_intro';
import AddStepCustomization from 'presentations/containers/add_step_customization';
import AddStepRevisions from 'presentations/containers/add_step_revisions';
import AddStepParticipants from 'presentations/containers/add_step_participants';
import { getPresentationDataFromForm } from 'presentations/utils';
import { scrollToModalTop } from 'common/utils';

const TOTAL_STEPS = 4;
const STEPS_MAPPING = [
  { component: AddStepIntro, contentClasses: "wide" },
  { component: AddStepCustomization, contentClasses: "wide" },
  { component: AddStepRevisions, contentClasses: "wide" },
  { component: AddStepParticipants }
];


export default class AddModal extends Component {
  constructor(props) {
    super(props);

    this.handleNext = this.handleNext.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleBack = this.handleBack.bind(this);
  }

  handleSubmit(formData) {
    const {
      fetchAll, createRequest, addParticipantRequest, addRevisionRequest, params,
      updateUser, userId
    } = this.props;

    const presentationData = getPresentationDataFromForm(formData);

    /* update user first and last names in parallel with presentation requests */
    const { first_name, last_name } = formData;
    updateUser({ id: userId, first_name, last_name });

    /* create presentation */
    return createRequest(presentationData).then(({ data }) => {
      /* add participants */
      const promises = formData.participants.map(p => (
        addParticipantRequest(data.id, { ...p, invite_message: formData.invite_message })
      ));
      return Promise.all(promises).then(() => {
        /* add revisions */
        const promises = formData.selected_revisions.map(r => (
          addRevisionRequest(data.id, { revision: r })
        ));
        return Promise.all(promises).then(() => {
          /* fetch update presentations list and go to just-created presentation */
          fetchAll();
          browserHistory.push(
            `/${params.subcategory}/${params.pageSlug}/presentations/${data.id}/`
          );
          this.handleClose();
        });
      });
    }).catch(res => {
      const errors = Object.values(res.data || {});
      if (res.status == 400 && errors[0] && errors[0][0]) {
        throw new SubmissionError({ _error: errors[0][0] });
      } else {
        throw new SubmissionError({ _error: 'Failed to launch presentation. Please try again.' });
      }
    });
  }

  handleClose() {
    this.props.reset();
    this.props.toggle();
  }

  handleBack() {
    const { changeStep, step } = this.props;
    changeStep(step - 1);
    scrollToModalTop("add-presentation-modal");
  }

  handleNext() {
    const { changeStep, step, submit } = this.props;

    if (step === TOTAL_STEPS) {
      submit();
    } else {
      changeStep(step + 1);
      scrollToModalTop("add-presentation-modal");
    }
  }

  render() {
    const {
      showing, step, handleSubmit, valid, submitting, error, submitFailed
    } = this.props;
    const stepDefinition = step? STEPS_MAPPING[step - 1] : null;
    const Step = stepDefinition? stepDefinition.component : null;
    const contentClasses = stepDefinition? stepDefinition.contentClasses : "";

    return (
      <ModalDialog modalOpen={showing} closeAction={this.handleClose}
        modalHeader={`Presentation - Step ${step} of ${TOTAL_STEPS}`}
        dialogClasses="add-presentation-modal" contentClasses={contentClasses || ""}>

        <Form onSubmit={handleSubmit(this.handleSubmit)}>
          <Step />
        </Form>

        <div className="modal-actions">
          <div className="row">
            <div className="columns small-16">
              { step > 1 &&
              <button className="btn btn-text btn-back" onClick={this.handleBack}>
                <i className="fa fa-angle-left" /> Back
              </button> }

              { step < TOTAL_STEPS?
              <button className="btn btn-primary" onClick={this.handleNext} disabled={!valid}>
                Next
              </button>:
              <AnimatedButton processing={submitting} onClick={this.handleNext}
                 label="Launch Presentation Site" disabled={!valid && !submitFailed}
                 processingLabel="Launching..." errorMsg={error || submitFailed} /> }

              <button className="btn btn-text" onClick={this.handleClose}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </ModalDialog>
    );
  }
};

AddModal.propTypes = {
  fetchAll: PropTypes.func.isRequired,
  createRequest: PropTypes.func.isRequired,
  addParticipantRequest: PropTypes.func.isRequired,
  addRevisionRequest: PropTypes.func.isRequired,
  changeStep: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  updateUser: PropTypes.func.isRequired,
  showing: PropTypes.bool.isRequired,
  step: PropTypes.number.isRequired,
  userId: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./presentations/components/add_modal.jsx